/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsUserControllerFindAllQueryResponse,
  TelegramProductsUserControllerFindAllQueryParams,
  TelegramProductsUserControllerFindAll401,
} from '../types/TelegramProductsUserControllerFindAll.ts';

function getTelegramProductsUserFindAllUrl() {
  const res = { method: 'GET', url: `/api/user/telegram/products` as const };
  return res;
}

/**
 * {@link /api/user/telegram/products}
 */
export async function telegramProductsUserFindAll(
  params?: TelegramProductsUserControllerFindAllQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsUserControllerFindAllQueryResponse,
    ResponseErrorConfig<TelegramProductsUserControllerFindAll401>,
    unknown
  >({ method: 'GET', url: getTelegramProductsUserFindAllUrl().url.toString(), params, ...requestConfig });
  return res.data;
}
